import { render, staticRenderFns } from "./BusinessContact.vue?vue&type=template&id=c4317238"
import script from "./BusinessContact.vue?vue&type=script&lang=js"
export * from "./BusinessContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports